// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'

import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store'
import VueMatomo from 'vue-matomo'

// import './assets/css/fonts.css'
import './assets/css/all.css'
import './assets/css/single-page.css'
import './assets/css/map.css'
import './assets/css/map-tools.css'
import './assets/css/map-sidebar.css'
import './assets/css/map-modal.css'
import './assets/css/map-print.css'
import './assets/css/responsive.css'
import './assets/css/statistiques.css'
import './assets/css/territoireList.css'

// import BootstrapVue from 'bootstrap-vue'
import 'babel-polyfill'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import axios from 'axios'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
axios.get('/api/v1/application/matomo', {})
  .then(response => {
    const config = response.data
    Vue.use(VueMatomo, {
      host: config.matomoUrl,
      siteId: parseInt(config.matomoSiteId, 10),
      enableLinkTracking: true,
      requireConsent: false
    })
    window._paq.push(['trackPageView'])
  })
  .catch(error => console.error('Erreur lors du chargement de la config Matomo', error))

Vue.use(Vuex)
// Vue.use(BootstrapVue)
Vue.use(Notifications, {
  velocity
})
Vue.config.productionTip = false

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
